const Taas = {
  symbol: 'taas',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM4 13v1.221h1.298V13H4zm1.298 4.774v-1.111h2.513v-1.221H4V19h5.075v-1.226H5.298zm17.627-2.332v1.22h3.777v1.112h-2.513V19H28v-3.558h-5.075zm3.798-1.162v-1.221h-3.8v1.22h3.8zm-16.411 1.162V19h3.81v-1.174h1.265v-2.384h-5.075zm3.777 2.332H11.61v-1.111h2.48v1.11zM10.312 13v1.221h5.075V13h-5.075zm6.334 2.442V19h3.81v-1.174h1.265v-2.384h-5.075zm3.772 2.332h-2.48v-1.111h2.48v1.11zM16.646 13v1.221h5.075V13h-5.075z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#002342"/><path fill="#FFF" d="M4 13h1.298v1.221H4V13zm1.298 4.774h3.777V19H4v-3.558h3.81v1.22H5.299v1.112zm17.627-2.332H28V19h-3.81v-1.226h2.512v-1.111h-3.777v-1.221zm3.798-1.162h-3.8v-1.221h3.8v1.22zm-16.411 1.162h5.075v2.384h-1.264V19h-3.811v-3.558zm3.777 2.332v-1.111H11.61v1.11h2.48zM10.312 13h5.075v1.221h-5.075V13zm6.334 2.442h5.075v2.384h-1.264V19h-3.81v-3.558zm3.772 2.332v-1.111h-2.48v1.11h2.48zM16.646 13h5.075v1.221h-5.075V13z"/></g>`;
  }
};
export default Taas;
